import React from 'react';
import axios from 'axios';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
    setHomeBookmark,
    toggleHomeBookmarkAsync,
    renameBookmarkAsync,
    fetchBookmarksAsync
} from '../../../../redux/bookmark/Actions';

import { withStyles } from '@material-ui/core/styles';
import {
    Modal,
    Typography,
    Checkbox,
    FormControlLabel,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@material-ui/core';

import { ViewFlagHover } from '../../Icons';

import DialogButton from '../../../Common/UI/Dialog/DialogButton';
import TextField from '../../../Common/UI/TextField';

class EditView extends React.Component {
    constructor(props) {
        super(props);

        this.editBookmark = this.editBookmark.bind(this);
        this.state = {
            nameError: null,
            homeView: this.props.homeBookmarkId === this.props.bookmark.id,
            loading: false
        };
    }

    editBookmark() {
        const {
            bookmark,
            onClose,
            homeBookmarkId,
            dispatchRenameBookmark,
            dispatchToggleHomeBookmark,
            dispatchFetchAllBookmarks,
            dispatchSetHomeBookmark
        } = this.props;
        const { homeView } = this.state;
        if (!bookmark.name) {
            return this.setState({
                nameError: 'View name cannot be null.'
            });
        }
        if (homeBookmarkId === bookmark.id || homeView) {
            dispatchSetHomeBookmark(homeView ? bookmark.id : -1);
            dispatchToggleHomeBookmark(homeView ? bookmark.id : -1);
        }
        dispatchRenameBookmark(bookmark.id, bookmark.name);
        onClose();
    }

    render() {
        const {
            classes,
            open,
            onClose,
            homeBookmarkId,
            editBookmark,
            bookmark,
            openRemoveBookmark
        } = this.props;
        const { nameError, homeView } = this.state;

        if (!bookmark) return <></>;

        return (
            <Dialog open={open} onClose={onClose} fullWidth>
                <DialogTitle disableTypography>
                    <ViewFlagHover className={classes.silver} />
                    <Typography variant="h4">Edit View</Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <TextField
                        label="Location name"
                        fullWidth
                        variant="outlined"
                        value={bookmark.name}
                        onChange={e =>
                            editBookmark({
                                ...bookmark,
                                name: e.target.value
                            })
                        }
                        error={Boolean(nameError)}
                        helperText={nameError}
                    />
                    <div>
                        <FormControlLabel
                            label="Set as Home View"
                            color="primary"
                            className={`${classes.grey} ${classes.label}`}
                            control={
                                <Checkbox
                                    checked={homeView}
                                    // onChange={(e, newValue) => dispatchSetHomeBookmark(newValue ? bookmark.id : null)}
                                    onChange={(e, newValue) =>
                                        this.setState({ homeView: newValue })
                                    }
                                />
                            }
                        />
                        <Typography
                            component="div"
                            variant="caption"
                            className={classes.grey}>
                            Load this view automatically when you open LandHawk
                        </Typography>
                    </div>
                </DialogContent>
                <DialogActions>
                    <DialogButton variant="contained" onClick={this.editBookmark}>
                        Save
                    </DialogButton>
                    <DialogButton variant="outlined" onClick={onClose}>
                        Cancel
                    </DialogButton>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = theme => ({
    grey: {
        color: theme.palette.grey.variant4
    },
    label: {
        '& > span': {
            fontSize: `${theme.typography.body2.fontSize} !important`
        }
    },
    silver: {
        '& > path:last-child': {
            fill: theme.palette.secondary.light
        },
        '& > path:first-child': {
            fill: theme.palette.grey.variant3
        }
    }
});

const mapStateToProps = state => ({
    homeBookmarkId: state.bookmarkReducer.homeBookmarkId
});

const mapDispatchToProps = dispatch => ({
    dispatchSetHomeBookmark: id => dispatch(setHomeBookmark(id)),
    dispatchRenameBookmark: (id, name) => dispatch(renameBookmarkAsync(id, name)),
    dispatchToggleHomeBookmark: id => dispatch(toggleHomeBookmarkAsync(id)),
    dispatchFetchBookmarks: () => dispatch(fetchBookmarks())
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
)(EditView);
